import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, HardHat, ClipboardList, Home, Wrench, Briefcase, Server, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import PageHero from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { services } from '../mockData';

const iconMap = { Building2, HardHat, ClipboardList, Home, Wrench, Briefcase, Server };

export default function ServicesPage() {
  const navigate = useNavigate();

  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Solutions Built on"
        accent="Expertise"
        description="Comprehensive, professional services across construction, engineering, and industrial sectors — delivered with quality and integrity."
      />

      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = iconMap[service.icon];
              return (
                <Reveal key={service.id} delay={index * 0.08}>
                  <div
                    className="bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 group border border-gray-100 hover:border-brand-red hover:-translate-y-2 h-full flex flex-col"
                    data-testid={`service-card-${service.id}`}
                  >
                    <div className="w-16 h-16 bg-red-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-brand-red transition-colors">
                      <Icon className="w-8 h-8 text-brand-red group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="text-2xl font-bold text-charcoal mb-3 group-hover:text-brand-red transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                    <ul className="space-y-2 mb-6 flex-grow">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-sm text-gray-600">
                          <div className="w-1.5 h-1.5 bg-brand-red rounded-full mr-2"></div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => navigate('/contact')}
                      data-testid={`service-enquire-${service.id}`}
                      className="flex items-center text-brand-red font-semibold text-sm group-hover:gap-2 transition-all"
                    >
                      Enquire About This Service
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                    </button>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Band */}
      <section className="py-20 bg-charcoal">
        <div className="container mx-auto px-6 text-center">
          <Reveal>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Have a project in <span className="text-brand-red">mind?</span>
            </h2>
            <p className="text-gray-300 mb-8 max-w-xl mx-auto">
              Tell us what you need and our team will get back to you with a tailored solution.
            </p>
            <Button
              onClick={() => navigate('/contact')}
              data-testid="services-cta-button"
              className="bg-brand-red hover:bg-red-700 text-white font-semibold text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-xl transition-all group"
            >
              Get a Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
